var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"onManager":_vm.onManager,"data":_vm.data,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo,"hiddenKeys":['external_id', 'type', 'project_domain', 'tenant', 'status'],"show-name":false,"show-desc":false,"is-edit-name":!_vm.data.is_system,"is-edit-desc":!_vm.data.is_system}})
}
var staticRenderFns = []

export { render, staticRenderFns }